// extracted by mini-css-extract-plugin
export default {"stickyHeader":"Navbar_stickyHeader__1Z8He","underlineLink":"Navbar_underlineLink__h1Dpo"};